



























import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../system";
import DocumentManageNumberInputArea from "./DocumentManageNumberInputArea.vue";

@Component({
  components: {
    DocumentManageNumberInputArea,
  },
})
export default class DocumentManageNumberInputDialog extends Mixins(DialogMixin) {
  data(): any {
    return {
      editingManageNumberText: null as string,
      result: null as string,
    };
  }
  editingManageNumberText: string;
  result: string;

  $refs!: {
    manageNumberInput: DocumentManageNumberInputArea,
  };

  async show(manageNumberText: string): Promise<string> {
    return this.showModal(async () => {
      this.editingManageNumberText = manageNumberText;
      this.result = null;
      this.$nextTick(() => {
        this.focusToFirstInputSection();
      });
      await this.waitHidden();
      return this.result;
    });
  }

  setResultAndClose(): void {
    // nullだとキャンセルと判定されてしまうので空文字を返却している
    this.result = (this.editingManageNumberText != null)
      ? this.editingManageNumberText
      : "";
    this.editingManageNumberText = null;
    this.isVisible = false;
  }

  close(): void {
    this.result = null;
    this.editingManageNumberText = null;
    this.isVisible = false;
  }

  get isValid(): boolean {
    if (!this.editingManageNumberText) { return false; }
    const splitted = this.editingManageNumberText.split("-");
    const documentIdText = splitted[0];
    return (!!documentIdText && !!documentIdText.replace(/[^0-9]/g, ""));
  }

  onEnterKeyDown(): void {
    if (!this.isValid) { return; }
    this.setResultAndClose();
  }

  focusToFirstInputSection(): void {
    this.$refs.manageNumberInput.focusToFirstInputSection();
  }
}
